function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControl, FormHelperText, Input, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import uniqueId from 'lodash.uniqueid';
import { OptionGroup, withGroupedOptionHelpers, withStandardOptionHelpers } from '../../lib/optionHelpers';
import IconWrapper from '../../lib/IconWrapper';
import useFormHelpers from '../../hooks/useFormHelpers';
const useStyles = makeStyles(theme => ({
  checkedOptions: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  formControl: {
    width: '100%'
  }
}));
const MenuProps = {
  // https://github.com/mui-org/material-ui/issues/19245#issuecomment-620488016
  getContentAnchorEl: () => null,
  PaperProps: {
    style: {
      maxHeight: 250
    }
  }
};

let MultiSelect = ({
  className,
  getOptionLabel,
  getOptionValue,
  getOptionKey,
  getOptionType,
  helperText,
  icon,
  label,
  onChange,
  options,
  renderValue,
  value: checkedOptions = [],
  ...props
} = {}) => {
  const classes = useStyles();
  const [inputId] = useState(() => uniqueId('multiSelect_'));

  const defaultRenderValue = checkedOptions => React.createElement("div", {
    className: classes.checkedOptions
  }, checkedOptions.map(value => options.find(option => getOptionValue(option) === value)).map(getOptionLabel).join(', '));

  return React.createElement(IconWrapper, {
    icon: icon
  }, React.createElement(FormControl, {
    className: `${classes.formControl} ${className || ''}`
  }, React.createElement(InputLabel, {
    htmlFor: inputId,
    error: props.error
  }, label), React.createElement(Select, _extends({
    multiple: true,
    value: checkedOptions,
    onChange: ({
      target: {
        value: checkedOptions
      }
    }) => {
      const sortedValues = options.map(getOptionValue).filter(value => checkedOptions.includes(value));
      onChange(sortedValues);
    },
    input: React.createElement(Input, {
      id: inputId
    }),
    renderValue: renderValue || defaultRenderValue,
    MenuProps: MenuProps
  }, props), options.map(option => getOptionType(option) === 'group' ? React.createElement(OptionGroup, {
    key: getOptionKey(option)
  }, getOptionLabel(option)) : React.createElement(MenuItem, {
    key: getOptionKey(option),
    value: getOptionValue(option)
  }, React.createElement(Checkbox, {
    checked: checkedOptions.includes(getOptionValue(option))
  }), getOptionLabel(option)))), helperText && React.createElement(FormHelperText, {
    error: props.error
  }, helperText)));
};

MultiSelect.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
  helpeText: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  renderValue: PropTypes.func,
  value: PropTypes.array
};
MultiSelect = withGroupedOptionHelpers(withStandardOptionHelpers(MultiSelect));

const LinkedMultiSelect = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(MultiSelect, helpers);
};

LinkedMultiSelect.propTypes = {
  name: PropTypes.string.isRequired
};
export { MultiSelect, LinkedMultiSelect };